module.exports = __webpack_public_path__ + "img/G7.1f1092ae.png";